<template>
  <nav nav-mobile :data-open="mobile">
    <ul class="nav-mobile">
      <li v-for="(link, l) in config.header_menu" :key="l">
        <template v-if="link.tabs?.length > 0">
          <div class="nav-link nav-parent" :class="{ 'nav--open': active === l }" @click="handleMenuClick(l, $event)">
            <a :href="getLinkFieldUrl(link.link)" :target="link.link?.target" @click.stop>{{ link.label }}</a>
          </div>
          <div v-show="active === l" class="nav-items">
            <template v-for="(tab, s) in link.tabs" :key="s">
              <template v-for="(group, g) in tab.items" :key="g">
                <a class="nav-submenu-label" :href="getLinkFieldUrl(group.link)">{{ group.label }}</a>
                <ul v-if="renderMenu" class="nav-submenu">
                  <li v-for="(menu, m) in group.menu" :key="m">
                    <a :href="getLinkFieldUrl(menu.link)" :target="menu.link?.target" class="nav-link">{{ menu.label }}</a>
                  </li>
                </ul>
              </template>
            </template>
          </div>
        </template>
        <template v-else>
          <a :href="getLinkFieldUrl(link.link)" class="nav-link">{{ link.label }}</a>
        </template>
      </li>
    </ul>
    <div v-if="config.cta" class="nav-mobile-cta">
      <StoryblokComponent v-for="blok in config.cta" :key="blok._uid" :blok="blok" />
    </div>
  </nav>
</template>
<script setup>
  const active = ref(null);
  const renderMenu = ref(false);
  const isInteracting = ref(false);

  const handleMenuClick = (index, event) => {
    if (isInteracting.value) return;
    
    isInteracting.value = true;
    
    if (active.value === index) {
      active.value = null;
      renderMenu.value = false;
    } else {
      active.value = index;
      renderMenu.value = true;
    }
    
    requestAnimationFrame(() => {
      isInteracting.value = false;
    });
  };

  const props = defineProps({
    mobile: {
      type: Boolean,
      default: false,
    },
    config: {
      type: Object,
      required: true,
    },
  });

  watch(
    () => props.mobile,
    (isOpen) => {
      if (import.meta.client) {
        const body = document.body;
        body.classList.toggle("body--mobile-open", isOpen);
        
        if (!isOpen) {
          active.value = null;
          renderMenu.value = false;
        }
      }
    },
    { immediate: true }
  );

  onUnmounted(() => {
    if (import.meta.client) {
      document.body.classList.remove("body--mobile-open");
    }
  });
</script>
<style src="~/assets/scss/layout/header-mobile.scss" lang="scss"></style>
